<template>
  <div>
    <h1>News</h1>
    <div class="u_separation">
      <p>We're making history.</p>
    </div>
    <lm-swatches-block :space="43.75">
      <lm-container>
        <lm-row1 :md-gutter="35">
          <lm-col :md-span="6" v-for="article in list" :key="article.id">
            <lm-card :src="article.article_pic_syn" :title="article.article_title" :description="article.article_intro"
              height="386.11px" style="margin-bottom: 35px"
              @click="artilceIdArticle(article.id, article.article_url)"></lm-card>
          </lm-col>
        </lm-row1>
        <section class="btn-wrap" v-if="(pageNumber - 1) * pageSize < totalRow" @click="getPageData">
          <section class="primary-btn">More News</section>
        </section>
      </lm-container>
    </lm-swatches-block>
  </div>
</template>

<script>
import { frontArticles4Memu } from '@/api/api';
import { methodsMixins } from '@/mixins/index';

export default {
  mixins: [methodsMixins],
  data() {
    return {
      list: [],
      pageNumber: 1,
      pageSize: 8,
      totalRow: 0
    }
  },
  created() {
    this.getPageData()
  },
  methods: {
    getPageData() {
      frontArticles4Memu({
        memu1Id: 'y0lm76lhgr',
        memu2Id: 'y0lm77kcgi',
        pageNumber: this.pageNumber ++,
        pageSize: this.pageSize
      }).then(res => {
        const list = res.data.list;
        this.list = [...this.list, ...list.map((item, i) => {
          item.article_pic_syn = process.env.VUE_APP_RESOURCE + item.article_pic_syn;
          item.article_title = item.article_title.slice(0, 100) + '...'
          // item.article_intro = item.article_intro.slice(0, 84) + '...'
          return item;
        })]
        this.totalRow = res.data.totalRow;
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variable.scss';
@import '../home/index.scss';
</style>
